var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',_vm._l((_vm.faq),function(item,i){return _c('v-expansion-panel-content',{key:i,scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"question-text",domProps:{"innerHTML":_vm._s(item.question)}})]},proxy:true}],null,true)},[_vm._v(" "),_c('v-card',[_c('v-card-text',{domProps:{"innerHTML":_vm._s(item.answer)}})],1)],1)}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30399db2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/elements/Questions.vue
// module id = 9KkK
// module chunks = 0 6